export const LOTTIE_PLAYER_VERSION = "1.6.3"; 
export const LOTTIE_WEB_VERSION = "^5.10.0";
